import styled from "styled-components";

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
`;

export const FieldSearchContentMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible", "isHeaderVisible"].includes(prop),
})<{ isVisible: boolean; isHeaderVisible: boolean }>`
  height: ${({ theme, isVisible }) => (isVisible ? "100vh" : theme.spacing(7))};
  display: ${({ isVisible }) => (isVisible ? "block" : "flex")};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  position: ${({ isVisible }) => (isVisible ? "fixed" : "inherit")};
  z-index: ${({ isVisible }) => (isVisible ? 10 : 0)};
  background: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.white : "none"};
  padding: ${({ theme, isVisible }) =>
    isVisible ? "0" : `0 ${theme.spacing(2)}`};
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  width: 100%;
  top: ${({ isHeaderVisible }) => (isHeaderVisible ? "0" : "0")};
  left: 0;
`;

export const ModalContent = styled.div.withConfig({})<{}>`
  display: flex;
  height: auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  overflow-y: auto;
`;

export const FieldSearchHeaderMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  background-color: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.vividBlue : "transparent"};
  padding-top: ${({ theme, isVisible }) => (isVisible ? theme.spacing(2) : 0)};
  padding-bottom: 0;
  padding-left: ${({ isVisible }) => (isVisible ? "0" : "inherit")};
  padding-right: ${({ isVisible }) => (isVisible ? "0" : "inherit")};
  flex-direction: ${({ isVisible }) => (isVisible ? "column" : "row")};
  width: 100%;

  & > div {
    height: ${({ isVisible }) => (isVisible ? "fit-content" : "inherit")};
    align-items: center;
    display: flex;
  }

  & > button {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
    margin-left: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(2) : 0};
  }

  & > svg {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  }

  & svg {
    color: ${({ theme }) => theme.colors.white};
  }

  & input {
    background-color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.transparent : "inherit"};
    color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.white : theme.colors.darkGray};
    font-size: ${({ theme, isVisible }) =>
      isVisible ? theme.fontSizes.md : "inherit"};
    height: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(6) : "inherit"};
    width: 100%;

    &::placeholder {
      color: ${({ theme, isVisible }) =>
        isVisible ? theme.colors.white : theme.colors.darkGray};
    }
  }
`;

export const FieldSearchMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  height: ${({ isVisible }) => (isVisible ? "auto" : "inherit")};
  padding: ${({ theme }) =>
    (isVisible) =>
      isVisible ? `0` : `${theme.spacing(2)} 0`};
  /* gap: ${({ theme }) => theme.spacing(2)}; */
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > svg {
    height: ${({ theme }) => theme.spacing(3.2)};
    width: ${({ theme }) => theme.spacing(5.5)};
  }
`;

export const FieldSearchDropdownMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["type"].includes(prop),
})<{ type: string }>`
  padding-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;
export const GuestSelectorModalHeader = styled.div.withConfig({})`
  display: flex;
  height: auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  /* margin-top: 10px; */
  z-index: 10;
`;

export const GuestSelectorModalContent = styled.div.withConfig({})`
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 10;
  justify-content: center;
  padding-top: 15px;
`;

export const IconContent = styled.div.withConfig({})`
  display: flex;
  height: 100%;
  width: 10%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  z-index: 10;
  justify-content: center;
  padding-top: 10px;
`;

export const InfoContent = styled.div.withConfig({})`
  display: flex;
  height: auto;
  width: 90%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  z-index: 10;
  flex-direction: column;
  justify-content: center;
  /* padding-bottom: 10px; */
`;
